import * as Sentry from "@sentry/react";
import type { ReactNode } from "react";

interface ErrorBoundaryProps {
	children: ReactNode;
}

export function ErrorBoundary({ children }: ErrorBoundaryProps) {
	return (
		<Sentry.ErrorBoundary
			fallback={({ error, resetError }) => (
				<div className="flex min-h-screen items-center justify-center bg-gray-50">
					<div className="text-center">
						<h1 className="text-2xl font-bold text-gray-900">
							Something went wrong
						</h1>
						<p className="mt-2 text-gray-600">
							{error instanceof Error
								? error.message
								: "An unexpected error occurred"}
						</p>
						<button
							onClick={resetError}
							className="mt-4 rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
						>
							Try again
						</button>
					</div>
				</div>
			)}
			showDialog
		>
			{children}
		</Sentry.ErrorBoundary>
	);
}
